import { Image } from '@chakra-ui/react';
import needsAttention from '../../assets/images/icons/needs_attention.svg';

export const NeedsAttentionIcon = () => <Image src={needsAttention} />;
